<template>
  <div class="general-frame">
    <div class="general-neick">
      <div class="general-search-bar">
        <span>工单类型</span>
        <el-select
          style="width: 100%;width:130px;margin:0px 10px"
          v-model="isSystem"
        >
          <el-option label="系统工单" value="1"></el-option>
          <el-option label="人工工单" value="0"></el-option>
        </el-select>
        <span>问题类型</span>
        <el-select
          style="width: 100%;width:130px;margin:0px 10px"
          v-model="alarmType"
        >
          <el-option
            v-for="item in operationItem"
            :key="item.value"
            :label="item.typeName"
            :value="item.typeId"
          ></el-option>
        </el-select>
        <span>工单状态</span>
        <el-select
          style="width: 100%;width:130px;margin:0px 10px"
          v-model="status"
        >
          <el-option label="正在处理" value="2"></el-option>
          <el-option label="处理成功" value="5"></el-option>
          <el-option label="正常巡检" value="6"></el-option>
        </el-select>
        <span>站点名称</span>
        <el-input
          v-model="siteName"
          placeholder="请输入站点名称"
          style="width:230px;margin:0px 10px;"
        ></el-input>
        <span>创建时间</span>
        <el-date-picker
          v-model="startEndData"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="margin:0px 10px;width: 255px;"
          :picker-options="pickerOptions"
          @change="(bTime = startEndData[0]), (eTime = startEndData[1])"
        ></el-date-picker>
        <el-button
          v-if="global.power('operation/workorder.add') == true"
          type="primary"
          icon="el-icon-plus"
          class="elm-but"
          @click="
            (popup = 1), (popupName = '新增'), (executionStatus = 1), empty()
          "
          >新增</el-button
        >
        <el-button
          type="primary"
          class="elm-but"
          icon="el-icon-search"
          @click="getList()"
          >搜索</el-button
        >
        <el-button
          type="primary"
          class="elm-but"
          style="margin-left:15px"
          :loading="loading"
          @click="resetData()"
          icon="el-icon-refresh"
          >重置</el-button
        >
      </div>
      <div>
        <table class="surface">
          <thead>
            <tr>
              <th>站点名称</th>
              <th>站点类别</th>
              <th>巡检类型</th>
              <th>工单类型</th>
              <th>问题类型</th>
              <th>问题描述</th>
              <th>工单状态</th>
              <th>工单处理人</th>
              <th>创建时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in data" :key="index">
              <td>{{ item.siteName }}</td>
              <td>{{ getSiteType(item.siteType) }}</td>
              <td>
                {{
                  item.alarmClassify == "inspection" ? "正常巡检" : "问题工单"
                }}
              </td>
              <td>{{ item.isSystem == 1 ? "系统工单" : "人工工单" }}</td>
              <td>{{ alarmTypeStart(item.alarmType) }}</td>
              <td>{{ item.alarmContent }}</td>
              <td>{{ global.workOrderStart(item.status) }}</td>
              <td>{{ item.principal == null ? "暂无" : item.principal }}</td>
              <td>
                {{ parseTime(item.createTime, "{y}-{m}-{d} {h}:{i}:{s}") }}
              </td>
              <td class="color_button" style="padding-left: 10px;">
                <span
                  @click="edit(item)"
                  class="margin-but"
                  v-if="item.status == 0"
                  style="color:#E6A23C"
                >
                  <i class="el-icon-edit"></i>草稿
                </span>
                <span
                  class="margin-but"
                  @click="
                    (popup = 2), (assignForm.id = item.id), getDesignator()
                  "
                  v-if="
                    item.status == 1 &&
                      global.power('operation/workorder.assign') == true
                  "
                >
                  <i class="el-icon-position"></i>指派
                </span>
                <span
                  class="margin-but"
                  @click="
                    popup = 4;
                    handleForm.id = item.id;
                  "
                  v-if="item.status == 2 && user.id == item.dealOperator"
                >
                  <i class="el-icon-check"></i>工单处理
                </span>

                <span
                  class="margin-but"
                  @click="
                    popup = 3;
                    resultForm.id = item.id;
                    resultForm.status = item.status;
                  "
                  v-if="
                    item.status == 4 &&
                      user.userType == 'operatorMgr' &&
                      global.power('operation/workorder.resultConfirm') == true
                  "
                >
                  <i class="el-icon-check"></i>工单复核
                </span>
                <span
                  class="margin-but"
                  @click="deleteList(item.id)"
                  style="color:#f56c6c"
                  v-if="item.status == 0"
                >
                  <i class="el-icon-delete"></i>删除
                </span>
                <span>
                  <router-link
                    :to="{ path: '/workOrderDetails', query: { id: item.id } }"
                  >
                    <span> <i class="el-icon-search"></i>查看 </span>
                  </router-link>
                </span>
              </td>
            </tr>
          </tbody>
          <noData :data="data" />
        </table>
        <el-pagination
          background
          style="text-align: center;margin-top:15px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNum"
          layout="prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <!-- 新增编辑 -->
    <div class="window" v-show="popup == 1">
      <div style="width:40%;background:#FFF;border-radius: 4px;">
        <div class="window_top">
          <span>{{ popupName }}</span>
          <i
            class="el-icon-close"
            @click="(popup = 0), (form.id = null), empty()"
          ></i>
        </div>
        <div style="padding: 20px;" class="progressBar">
          <el-form
            :label-position="'right'"
            label-width="120px"
            ref="form"
            :model="form"
          >
            <el-form-item
              label="站点类别"
              prop="siteType"
              :rules="[{ required: true, message: '请选择状态' }]"
            >
              <el-select
                v-model="form.siteType"
                style="width: 100%"
                @change="getSiteName()"
              >
                <el-option label="厕所" value="1"></el-option>
                <el-option label="泵站" value="2"></el-option>
                <el-option label="传感器" value="3"></el-option>
                <el-option label="净味宝" value="4"></el-option>
                <el-option label="意见反馈" value="5"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="站点名称"
              prop="siteId"
              :rules="[{ required: true, message: '请选择站点名称' }]"
            >
              <el-select v-model="form.siteId" style="width: 100%">
                <el-option
                  v-for="item in siteNameList"
                  :key="item.value"
                  :label="item.siteName"
                  :value="item.siteId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="问题描述"
              prop="alarmContent"
              :rules="[{ required: true, message: '请输入问题描述' }]"
            >
              <el-input
                placeholder="请输入问题描述"
                v-model="form.alarmContent"
              ></el-input>
            </el-form-item>
            <el-form-item label="工单照片" prop="images">
              <el-upload
                ref="upload"
                :limit="5"
                :multiple="upload.IsMultiple"
                accept=".jpg, .png"
                :action="upload.url"
                :headers="upload.headers"
                :file-list="upload.fileList"
                :on-progress="handleFileUploadProgress"
                list-type="picture-card"
                :on-remove="handleRemove"
                :on-success="handleFileSuccess"
                style="text-align: left;"
              >
                <el-button slot="trigger" size="small" type="primary"
                  >选取文件</el-button
                >
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
        <div class="window_bottom">
          <el-button type="info" @click="popup = 0">取消</el-button>
          <el-button type="primary" @click="(submitStart = 1), submit('form')"
            >提交</el-button
          >
        </div>
      </div>
    </div>

    <!-- 指派 -->
    <div class="window" v-show="popup == 2">
      <div style="width:35%;background:#FFF;border-radius: 4px;">
        <div class="window_top">
          <span>工单指派</span>
          <i
            class="el-icon-close"
            @click="
              popup = 0;
              $refs.assignForm.resetFields();
              assignForm.id = null;
            "
          ></i>
        </div>
        <div style="padding: 20px 10px 0px 0px" class="progressBar">
          <el-form
            :label-position="'right'"
            label-width="120px"
            ref="assignForm"
            :model="assignForm"
          >
            <el-form-item
              label="指派人"
              prop="dealOperator"
              :rules="[{ required: true, message: '请选择指派人' }]"
            >
              <el-select v-model="assignForm.dealOperator" style="width: 100%">
                <el-option
                  v-for="item in designatorList"
                  :key="item.value"
                  :label="item.realName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                type="textarea"
                v-model="assignForm.comments"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="window_bottom">
          <el-button type="primary" @click="confirmAssign('assignForm')"
            >提交</el-button
          >
        </div>
      </div>
    </div>

    <!-- 工单复核 -->
    <div class="window" v-show="popup === 3">
      <div style="width:35%;background:#FFF;border-radius: 4px;">
        <div class="window_top">
          <span>工单复核</span>
          <i
            class="el-icon-close"
            @click="
              popup = 0;
              $refs.resultForm.resetFields();
              resultForm.id = null;
              resultForm.status = null;
              resultForm.uploadImages = [];
              upload.fileList = [];
            "
          ></i>
        </div>
        <div style="padding: 20px 10px 0px 0px" class="progressBar">
          <el-form
            :label-position="'right'"
            label-width="120px"
            ref="resultForm"
            :model="resultForm"
          >
            <el-form-item
              label="处理结果"
              prop="isConfirm"
              :rules="[{ required: true, message: '请选择处理结果' }]"
            >
              <el-select v-model="resultForm.isConfirm" style="width: 100%">
                <el-option label="问题已解决" :value="true"></el-option>
                <el-option label="问题未解决" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="comments">
              <el-input
                type="textarea"
                v-model="resultForm.comments"
              ></el-input>
            </el-form-item>
            <el-form-item label="工单照片" prop="uploadImages">
              <el-upload
                ref="upload"
                :limit="5"
                :multiple="upload.IsMultiple"
                accept=".jpg, .png"
                :action="upload.url"
                :headers="upload.headers"
                :file-list="upload.fileList"
                :on-progress="handleFileUploadProgress"
                list-type="picture-card"
                :on-remove="handleRemove"
                :on-success="handleFileSuccess"
                style="text-align: left;"
              >
                <el-button slot="trigger" size="small" type="primary"
                  >选取文件</el-button
                >
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
        <div class="window_bottom">
          <el-button type="primary" @click="confirmResult('resultForm')"
            >提交</el-button
          >
        </div>
      </div>
    </div>

    <!-- 工单处理 -->
    <div class="window" v-show="popup === 4">
      <div style="width:35%;background:#FFF;border-radius: 4px;">
        <div class="window_top">
          <span>工单处理</span>
          <i
            class="el-icon-close"
            @click="
              popup = 0;
              $refs.handleForm.resetFields();
              handleForm.id = null;
              handleForm.uploadImages = [];
              upload.fileList = [];
            "
          ></i>
        </div>
        <div style="padding: 20px 10px 0px 0px" class="progressBar">
          <el-form
            :label-position="'right'"
            label-width="120px"
            ref="handleForm"
            :model="handleForm"
          >
            <el-form-item
              label="处理结果"
              prop="isSure"
              :rules="[{ required: true, message: '请选择处理结果' }]"
            >
              <el-select v-model="handleForm.isSure" style="width: 100%">
                <el-option label="问题已处理" :value="true"></el-option>
                <el-option label="问题无法处理" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="comments">
              <el-input
                type="textarea"
                v-model="handleForm.comments"
              ></el-input>
            </el-form-item>
            <el-form-item label="工单照片" prop="uploadImages">
              <el-upload
                ref="upload"
                :limit="5"
                :multiple="upload.IsMultiple"
                accept=".jpg, .png"
                :action="upload.url"
                :headers="upload.headers"
                :file-list="upload.fileList"
                :on-progress="handleFileUploadProgress"
                list-type="picture-card"
                :on-remove="handleRemove"
                :on-success="handleFileSuccess"
                style="text-align: left;"
              >
                <el-button slot="trigger" size="small" type="primary"
                  >选取文件</el-button
                >
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
        <div class="window_bottom">
          <el-button type="primary" @click="handleFormResult('handleForm')"
            >提交</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import noData from "@/components/html/noData";

export default {
  components: {
    noData
  },
  data() {
    return {
      submitStart: 0,
      executionStatus: 0, //执行状态
      keepStart: 0,
      problemList: [],
      designatorList: [], //指派人
      pageSize: 10, //每页10条
      pageNum: 1, //当前页码
      total: 0,
      siteNameList: [],
      siteId: null,
      siteName: null,
      alarmTitle: null,
      alarmType: null,
      user: {},
      status: null,
      startEndData: null,
      isSystem: null,
      bTime: "",
      eTime: "",
      data: null,
      siteData: [],
      companyData: [],
      operationItem: [],
      multiDileDetails: [],
      popup: 0,
      loading: false,
      popupName: "新增",
      form: {
        alarmContent: null,
        alarmTitle: null,
        alarmType: null,
        dealEndDate: null,
        id: null,
        siteId: null,
        siteType: null,
        status: null,
        images: [],
        alarmClassify: "",
        dealOperator: null
      },
      assignForm: {
        dealOperator: null,
        comments: "",
        id: null
      },
      resultForm: {
        isConfirm: null,
        comments: null,
        id: null,
        dealOperator: null,
        status: null,
        uploadImages: []
      },
      handleForm: {
        isSure: null,
        comments: null,
        id: null,
        uploadImages: []
      },
      //日期之后禁止选中
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如
        }
      },
      upload: {
        // 是否禁用上传
        isUploading: false,
        // 设置上传的请求头部
        // 上传的地址
        url: "common/upload",
        // 上传的文件列表
        fileList: [],
        // 是否支持多选文件
        IsMultiple: true
      }
    };
  },
  methods: {
    getList() {
      this.get("operation/management/list", {
        siteId: this.siteId,
        alarmTitle: this.alarmTitle,
        alarmType: this.alarmType,
        status: this.status,
        beginTime: this.bTime,
        endTime: this.eTime,
        isSystem: this.isSystem,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        siteName: this.siteName
      }).then(res => {
        this.data = res.data.rows;
        this.total = res.data.total;
        for (var i = 0; i < this.data.length; i++) {
          if (
            this.data[i].status == 0 &&
            this.data[i].creator != localStorage.getItem("useId")
          ) {
            this.data.splice(i, 1);
          }
        }
      });
    },

    //问题类型
    questionType() {
      //问题类型渲染列表(全部数据)
      this.get("operation/management/getAlarmTypeList", {}).then(res => {
        this.operationItem = res.data.rows;
      });
      //问题类型渲染列表(不同的用户显示不同的数据)
      this.get("operation/management/getAlarmType", {}).then(res => {
        this.problemList = res.data.rows;
      });
    },

    //站点名称
    getSiteName() {
      this.get("operation/management/getSiteNameList", {
        siteType: this.form.siteType
      }).then(res => {
        this.siteNameList = res.data.rows;
      });
    },

    //指派人
    getDesignator() {
      var that = this;
      that
        .get("operation/management/getCompanyPesonList", {})
        .then(function(res) {
          that.designatorList = res.data.rows;
        });
    },

    //清空
    empty() {
      this.larmClassify = null;
      this.alarmContent = null;
      this.alarmTitle = null;
      this.alarmType = null;
      this.dealEndDate = null;
      this.siteType = null;
      this.form.images = [];
      this.upload.fileList = [];
      this.keepStart = 0;
      this.siteName = null;
      this.$refs.form.resetFields();
    },

    //选择正常巡检后,清空问题工单
    alarmClassifyStart() {
      if (this.form.alarmClassify == "inspection") {
        this.form.alarmType = "";
        this.form.alarmContent = "";
        this.form.dealEndDate = "";
      }
    },

    //重置
    resetData() {
      this.siteId = null;
      this.alarmTitle = null;
      this.alarmType = null;
      this.siteType = null;
      this.status = null;
      this.startEndData = null;
      this.bTime = null;
      this.eTime = null;
      this.isSystem = null;
      this.siteName = null;
      this.getList();
    },

    //问题类型
    alarmTypeStart(val) {
      var data = this.operationItem.filter(function(item) {
        return item.typeId == val;
      });
      return data.length > 0 ? data[0].typeName : "暂无";
    },

    // 文件上传中处理
    handleFileUploadProgress() {
      this.upload.isUploading = true;
    },

    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.upload.isUploading = false;
      fileList[fileList.length - 1].url = response.url;
      this.upload.fileList = fileList;
      this.$message({
        type: "success",
        message: response.msg
      });
    },

    //编辑
    edit(item) {
      this.popup = 1;
      this.popupName = "编辑";
      this.executionStatus = 2;
      this.form.id = item.id;
      this.form.siteType = item.siteType.toString();
      this.getSiteName();
      this.form.siteId = item.siteId;
      this.form.alarmClassify = item.alarmClassify;
      this.form.alarmContent = item.alarmContent;
      this.form.alarmTitle = item.alarmTitle;
      this.form.dealEndDate = item.dealEndDate;
      this.form.images = item.images;
      this.upload.fileList = [];
      this.form.siteId = item.siteId;
      this.get("operation/management/getAlarmType", {
        alarmType: item.alarmType
      }).then(res => {
        this.problemList = res.data.rows;
        this.form.alarmType = item.alarmType;
      });

      const file = [];
      if (item.images && JSON.parse(item.images).length > 0) {
        JSON.parse(item.images).forEach(function(v) {
          file.push({
            name: v.fileName,
            url: v.filePath
          });
        });
        this.upload.fileList = file;
      }
    },

    /*图片上传删除*/
    handleRemove(file, fileList) {
      if (this.upload.fileList.length > 0) {
        this.upload.fileList = this.upload.fileList.filter((item, index) => {
          // 根据文件名称进行删除
          return item.name != file.name;
        });
      }
    },

    //提交
    submit(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          //上传图片 start
          const file = [];
          if (this.upload.fileList.length > 0) {
            this.upload.fileList.forEach(function(v) {
              file.push({
                fileName: v.name,
                filePath: v.url
              });
            });
            this.form.images = JSON.stringify(file);
          } else {
            this.form.images = "";
          }
          //上传图片 end
          // 默认问题工单，且状态默认为正在处理
          this.form.alarmClassify = "operation";
          this.form.status = 2;
          if (this.form.siteType == 2 || this.form.siteType == 3) {
            this.form.alarmType = 4001;
          } else if (this.form.siteType == 1) {
            this.form.alarmType = 4002;
          }
          /*if (this.form.alarmClassify == "inspection") {
            this.form.status = 6;
            this.form.alarmType = null;
            this.form.alarmContent = null;
            this.form.dealEndDate = null;
          } else if (this.form.alarmClassify == "operation") {
            this.form.status = 2;
          }
          if (this.executionStatus != 0 && this.submitStart == 0) {
            this.form.status = 0;
          }*/
          var form = this.form;
          if (this.popupName == "新增") {
            this.postNo("operation/management/add", form).then(res => {
              if (res.data.code == 200) {
                this.getList();
                this.popup = 0;
                this.empty();
                this.$message({
                  type: "success",
                  message: "操作成功!"
                });
              } else {
                this.$message.error(res.data.returnMsg);
              }
            });
          } else if (this.executionStatus == 2 && this.submitStart == 0) {
            this.put("operation/management/edit", form).then(res => {
              if (res.data.code == 200) {
                this.getList();
                this.popup = 0;
                this.empty();
                this.$message({
                  type: "success",
                  message: "编辑成功!"
                });
              } else {
                this.$message.error(res.data.returnMsg);
              }
            });
          } else if (this.executionStatus == 2 && this.submitStart == 1) {
            this.put("operation/management/turnFormal", form).then(res => {
              if (res.data.code == 200) {
                this.getList();
                this.popup = 0;
                this.empty();
                this.$message({
                  type: "success",
                  message: "编辑成功!"
                });
              } else {
                this.$message.error(res.data.returnMsg);
              }
            });
          }
        }
      });
    },

    //提交
    submit1111(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          var that = this;
          const file = [];
          if (that.upload.fileList.length > 0) {
            that.upload.fileList.forEach(function(v) {
              file.push({
                fileName: v.name,
                filePath: v.url
              });
            });
            that.form.images = JSON.stringify(file);
          } else {
            that.form.images = "";
          }

          that.put("operation/management/edit", that.form).then(function(res) {
            if (res.data.code == 200) {
              that.getList();
              that.popup = 0;
              that.empty();
              that.$message({
                type: "success",
                message: "操作成功!"
              });
            } else {
              that.$message.error(res.data.returnMsg);
            }
          });
        }
      });
    },

    //草稿
    preservation(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          var that = this;
          const file = [];
          if (that.upload.fileList.length > 0) {
            that.upload.fileList.forEach(function(v) {
              file.push({
                fileName: v.name,
                filePath: v.url
              });
            });
            that.form.images = JSON.stringify(file);
          } else {
            that.form.images = "";
          }
          that.form.status = 0;
          that.form.dealOperator = localStorage.getItem("useId");
          var form = that.form;
          that.postNo("operation/management", form).then(function(res) {
            if (res.data.code == 200) {
              that.getList();
              that.popup = 0;
              that.empty();
              that.$message({
                type: "success",
                message: "保存成功!"
              });
            } else {
              that.$message.error(res.data.returnMsg);
            }
          });
        }
      });
    },

    //工单复核
    confirmResult(resultForm) {
      this.$refs[resultForm].validate(valid => {
        if (valid) {
          var resultForm = this.resultForm;
          this.resultForm.dealOperator = localStorage.getItem("useId");
          const file = [];
          if (this.upload.fileList.length > 0) {
            this.upload.fileList.forEach(function(v) {
              file.push({
                fileName: v.name,
                filePath: v.url
              });
            });
            this.resultForm.uploadImages = JSON.stringify(file);
          } else {
            this.resultForm.uploadImages = "";
          }
          this.postNo("operation/management/doResultConfirm", resultForm).then(
            res => {
              if (res.data.code == 200) {
                this.getList();
                this.popup = 0;
                this.$refs.resultForm.resetFields();
                this.upload.fileList = [];
                this.$message({
                  type: "success",
                  message: res.data.msg
                });
              } else {
                return this.$message.error(res.data.msg);
              }
            }
          );
        }
      });
    },

    //工单处理
    handleFormResult(handleForm) {
      this.$refs[handleForm].validate(valid => {
        if (valid) {
          var handleForm = this.handleForm;
          const file = [];
          if (this.upload.fileList.length > 0) {
            this.upload.fileList.forEach(function(v) {
              file.push({
                fileName: v.name,
                filePath: v.url
              });
            });
            this.handleForm.uploadImages = JSON.stringify(file);
          } else {
            this.handleForm.uploadImages = "";
          }
          this.postNo("operation/management/feedback", handleForm).then(res => {
            if (res.data.code == 200) {
              this.getList();
              this.popup = 0;
              this.$refs.handleForm.resetFields();
              this.upload.fileList = [];
              this.$message({
                type: "success",
                message: res.data.msg
              });
            } else {
              return this.$message.error(res.data.msg);
            }
          });
        }
      });
    },

    //指派工单
    confirmAssign(assignForm) {
      this.$refs[assignForm].validate(valid => {
        if (valid) {
          var assignForm = this.assignForm;
          this.postNo("/operation/management/assign", assignForm).then(res => {
            if (res.data.code == 200) {
              this.getList();
              this.popup = 0;
              this.$refs.assignForm.resetFields();
              this.$message({
                type: "success",
                message: res.data.msg
              });
              this.assignForm.id = null;
            } else {
              return this.$message.error(res.data.msg);
            }
          });
        }
      });
    },

    //pageNum 改变时会触发
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList(); //调用终端数据接口
    },

    //pageSize改变时会触发
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
    },

    //列表删除
    deleteList(id) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteNo("operation/management/" + id, {}).then(res => {
            if (res.data.code == 200) {
              this.getList();
              this.$message({
                message: "删除成功!",
                type: "success"
              });
            } else {
              this.$message.error(res.data.returnMsg);
            }
          });
        })
        .catch(() => {});
    },

    //站点类别
    getSiteType(val) {
      return val === 1
        ? "厕所"
        : val === 2
        ? "泵站"
        : val === 3
        ? "传感器"
        : val === 4
        ? "除臭机"
        : val === 5
        ? "意见反馈"
        : "其他";
    }
  },
  mounted() {
    this.getList();
    this.questionType();
    this.upload.url = this.global.http + "common/upload";
    this.user = JSON.parse(localStorage.getItem("data"));
  },
  created: function() {}
};
</script>
<style scoped>
.clearStyle /deep/ .el-input--prefix .el-input__inner {
  background: #fff;
  border: 0px;
  box-shadow: navajowhite;
  box-shadow: none;
  color: #000;
  border: 1px solid;
  border: 1px solid #dcdfe6;
}

.window >>> .el-input__inner {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/pages/menu/maintenance/workOrder.vue